var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"new-meal"}},[_c('form-meal',{attrs:{"editingMode":"create"}}),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }